<template>
  <widget
    @closed="$emit('closed')"
    @search="openSearch"
    title="filiali/cantieri"
    icon="mdi-account-group"
    :bgColor="colors.orange"
    dark
    searchButton
    scroll
  >
    <transition name="fade" appear>
      <v-row v-if="searchBtn" class="px-3 my-3 mx-0 search-bar">
        <v-text-field
          class="mx-1"
          label="Ricerca rapida"
          clearable
          v-model="search"
        ></v-text-field>
      </v-row>
    </transition>
    <template>
      <div style="  height: 200px;
  overflow-y: auto;
  margin-bottom: 20px;">
        <v-simple-table height="300px">
        <template v-slot:default>
          <tbody>
            <tr v-for="item in filteredList" :key="item.i">
              <td class="font-weight-black text-caption">Codice</td>
              <td class="text-caption">{{ item.codice }}</td>
              <td class="font-weight-black text-caption">Descrizione</td>
              <td class="text-caption">{{ item.descrizione }}</td>
            </tr>
          </tbody>
        </template>
      </v-simple-table>
      </div>

    </template>
  </widget>
</template>



<script>
import { mapActions, mapGetters } from "vuex";
import Widget from "./Widget.vue";
import mixin from "@/mixin";

export default {
  name: "filiali-cantieri",
  mixins: [mixin],
  components: {
    Widget,
  },
  mounted() {
    this.fetchData();
  },
  data() {
    return {
      searchBtn: false,
      show: false,
      search: "",
    };
  },
  methods: {
    ...mapActions({
      fetchData: "widget/fetchFilCant",
    }),
    openSearch() {
      this.searchBtn = !this.searchBtn;
      this.search = "";
    },
  },
  computed: {
    ...mapGetters({
      items: "widget/filCant",
    }),
    filteredList() {
      return this.items.filter((item) => {
        return `${item.codice}${item.descrizione}`
          .trim()
          .toLowerCase()
          .includes(this.search.toLowerCase().trim());
      });
    },
  },
};
</script>

<style scoped>
.space {
  padding: 0px !important;
  margin: 0px !important;
}
.v-list-item.theme--light {
  padding-left: 0px !important;
}

.v-card__subtitle,
.v-card__text,
.v-card__title {
  padding: 0;
}

.v-card {
  overflow-wrap: inherit;
  white-space: pre;
}
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s ease;
}

.fade-enter-from,
.fade-leave-to {
  transition: opacity 0.2s ease;
}
</style>